const selectors = {
    el: '.js-load-page:not(.is-initialized)',
    content: '.js-load-page-content'
}

const classes = {
    loading: 'is-loading',
    loaded: 'is-loaded'
}

let abortController;

const loadPage = (href, wrapper) => {
    abortController = new AbortController();

    const { signal } = abortController;
    
    fetch(href, { signal })
        .then(
            response => response.text(),
        )
        .then((res) => {
            window.history.replaceState({ path: href }, '', href);

            const parser = new DOMParser();
            const doc = parser.parseFromString(res, 'text/html');
            const content = doc.querySelector(selectors.content);

            wrapper.classList.add(classes.loaded);

            setTimeout(() => {
                wrapper.innerHTML = content.innerHTML;
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => { // Appending takes more than 1 frame on FF
                        document.dispatchEvent(new CustomEvent('domUpdated'));

                        wrapper.classList.remove(classes.loading);
                    });
                });
            }, 400);
        })
        .catch((err) => {
            if (err.name === 'AbortError') return;
            console.warn(err);
        });
}

const init = () => {
    const els = document.querySelectorAll(selectors.el);
    const pageUrl = window.location.href;
    els.forEach(el => {
        el.classList.add('is-initialized');
        
        const modal = document.querySelector(el.dataset.modalId);
        const wrapper = document.querySelector(el.dataset.wrapper);
        
        el.addEventListener('click', e => {
            e.preventDefault();

            if (wrapper.matches(`.${classes.loaded}`)) {
                window.history.pushState({ path: el.href }, '', el.href);
            } else {
                wrapper.classList.add(classes.loading);
    
                if (abortController) {
                    // In case a page is already loadind, abort.
                    abortController.abort();
                }
                loadPage(el.href, wrapper, modal);
            }
        });

        if (modal) {
            const observer = new MutationObserver(() => {
                const isOpen = modal.modal.isOpen;
    
                if (!isOpen) {
                    window.history.replaceState({ path: pageUrl }, '', pageUrl);
                    
                    if (abortController) {
                        // In case a page is already loadind, abort.
                        abortController.abort();
                    }
                }
            });
    
            observer.observe(modal, { attributes: true });
        }
    });
};

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;